var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.9981 0C35.9997 0 0 35.9997 0 79.9981C0 123.997 35.9997 159.996 79.9981 159.996C123.997 159.996 159.996 123.997 159.996 79.9981C159.996 35.9997 124 0 79.9981 0ZM79.9981 143.999C44.7971 143.999 15.9974 115.199 15.9974 79.9981C15.9974 44.7971 44.8009 16.0011 79.9981 16.0011C115.195 16.0011 143.999 44.8009 143.999 80.0019C143.999 115.203 115.199 144.003 79.9981 144.003V143.999Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9996 31.998C53.5998 31.998 32 53.5979 32 79.9977C32 106.397 53.5998 127.997 79.9996 127.997C106.399 127.997 127.999 106.397 127.999 79.9977C127.999 53.5979 106.399 31.998 79.9996 31.998ZM79.9996 111.996C62.401 111.996 48.0011 97.5963 48.0011 79.9977C48.0011 62.3991 62.401 47.9992 79.9996 47.9992C97.5982 47.9992 111.998 62.3991 111.998 79.9977C111.998 97.5963 97.5982 111.996 79.9996 111.996Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9972 95.9983C88.8344 95.9983 95.9983 88.8344 95.9983 79.9972C95.9983 71.16 88.8344 63.9961 79.9972 63.9961C71.16 63.9961 63.9961 71.16 63.9961 79.9972C63.9961 88.8344 71.16 95.9983 79.9972 95.9983Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoals);
export default __webpack_public_path__ + "static/media/goals.7bd87905.svg";
export { ForwardRef as ReactComponent };